import moment from 'moment';
import Vue from 'vue';

/**
 * Formats date to 'D.MMMM.YYYY'
 * @param  {Number} value Date in milliseconds
 * @return {String}       Date in string human readable and formated to locale
 **/
Vue.filter('date', function (value) {
  if (!value) return '';
  return moment(value).format('D MMM YYYY');
});